import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { millisecondsInMinute } from "date-fns";

import { api } from "@contexts";
import type { Patient, Request, RequestDetail, RequestAttachment } from "@interfaces";

export type RequestAPIResponse = {
  request: Request;
  details: RequestDetail[];
  patient: Patient;
  attachments: RequestAttachment[];
};

export const useRequestData = () => {
  const { requestId = "" } = useParams();

  return useQuery({
    queryKey: ["request", requestId],
    queryFn: () =>
      api<RequestAPIResponse>({
        url: `/requests/${requestId}`,
      }),
    staleTime: millisecondsInMinute * 5,
    enabled: Boolean(requestId),
  });
};
